import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { Tag } from '.';

type TagFilterParameterProps = {
  // The plural name of the resources being fetched, e.g. "lists"
  resources: string;

  // An example url for the endpoint, without any query parameters
  url: string;
};

/**
 * The tagged query parameter
 *
 * Every endpoint that fetches a page of taggable resources accepts this, so
 * it's documented in one place to keep the wording consistent
 */
export function TagFilterParameter({
  resources,
  url,
}: TagFilterParameterProps): ReactElement {
  return (
    <li>
      <Tag intent="warning" icon={faQuestion} show>
        optional
      </Tag>
      <code className="attribute">
        tagged
        <span className="attribute-type">string</span>
      </code>
      <code className="attribute-example">{url}?tagged=recipe-app</code>
      <span className="attribute-description">
        <p>
          Only fetch {resources} with a <Link to="/docs/tags">tag</Link>.
        </p>
        <p>
          Separate tags with commas to fetch {resources} with any of the tags (
          <code>?tagged=recipe-app,cookbook-app</code>), or repeat the parameter
          to fetch {resources} with all of them (
          <code>?tagged=recipe-app&amp;tagged=production</code>).
        </p>
      </span>
    </li>
  );
}
